export const convertSvgToScreen = (
  svgElement: SVGGraphicsElement | null,
  svgX: number,
  svgY: number
): { x: number; y: number } => {
  if (!svgElement) {
    return { x: 0, y: 0 };
  }

  const screenCTM = svgElement.getScreenCTM();

  if (!screenCTM) {
    return { x: 0, y: 0 };
  }

  const point = new DOMPoint(svgX, svgY).matrixTransform(screenCTM);

  return {
    x: point.x + window.scrollX,
    y: point.y + window.scrollY,
  };
};
